import { FormEvent, useCallback, useEffect, useState } from 'react';
import { useGenerateContext } from '../Contexts/Generate.Context';
import { GenerateResponseOfBaseModel } from '../Clients/reminds';
import { Button } from '../Components/Button/Button';
import { Input } from '../Components/TextArea/TextArea';
import { useQueryClient } from '@tanstack/react-query';

export const Home = () => {
  const { generate } = useGenerateContext();
  const [newTask, setNewTask] = useState('');
  const [addedTask, setAddedTask] = useState<GenerateResponseOfBaseModel | undefined>();
  const [expanded, setExpanded] = useState(false);

  const queryClient = useQueryClient();

  const handleGenerateSucess = useCallback((data: GenerateResponseOfBaseModel) => {
    queryClient.invalidateQueries({ queryKey: [data.category] });
    setAddedTask(data);
    setNewTask('');
  }, []);

  const handleAddTask = () => {
    if (newTask.trim() !== '') {
      generate({ prompt: newTask }, handleGenerateSucess);
    }
  };

  useEffect(() => {
    setExpanded(true);
  }, []);

  const handleInputChange = useCallback((event: FormEvent<HTMLInputElement>) => {
    setNewTask(event.currentTarget.value);
  }, []);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
      }}
    >
      <Input
        value={newTask}
        onChange={handleInputChange}
        style={{
          width: expanded ? '60%' : '0%',
          transition: 'width 1s cubic-bezier(.62,.07,.45,.96)',
        }}
      />
      <Button onClick={handleAddTask}>Submit</Button>

      {JSON.stringify(addedTask?.category)}
      {JSON.stringify(addedTask?.data)}
    </div>
  );
};
